<div class="mandatory-field">
    * Obligatori
</div>

@let _currentForm = currentForm();
@let _openedComponentSection = openedComponentSection();
@let _openedDynFormSection = openedDynFormSection();

<div  class="all-sections">
    <mat-accordion #accordion *ngIf="_currentForm != null" displayMode="flat" hideToggle="true"  >

        <ng-container *ngFor="let section of _currentForm.sections; let index = index">
            <!-- {{index}} [{{section.name}}]  -->
            <mat-expansion-panel *ngIf="formSectionMetadataState()[index].shown == true"  style="position: relative;"
                (click)="clickOnExpansionPanel(section,ep._isExpanded())" class="mat-elevation-z81">

                <mat-expansion-panel-header class="header" #ep>
                   
                    <mat-panel-title>

                        <div class="d-flex flex-column  justify-content-center white" style="height: 40px;  z-index: 99;">
                            <div class="d-flex align-items-center" style="width: 100%; position: relative;">
                                <div style="width:20px;">
                                    <div class="d-flex align-items-center justify-content-center  outer-circle" 
                                        [class.outer-circle-active]="ep._isExpanded() == true">
                                        <div class="inner-circle" [class.inner-circle-error]="formSectionMetadataState()[index].validForm == false && ep._isExpanded() == false"
                                            [class.inner-circle-active]="formSectionMetadataState()[index].validForm == true || ep._isExpanded() ==true "
                                            [class.inner-circle-empty]="formSectionMetadataState()[index].validForm == null">
                                        </div>
                                    </div>
                                </div>
                                <div [id]="'section-validation-'+section.id"></div>
                                <div class="d-flex flex-column" style="padding-left: 8px;">
                                    <div class="eac-display-4" [class.alert-msg]="formSectionMetadataState()[index].validForm == false  && ep._isExpanded() == false">{{section.name}}
                                        <span class="required" *ngIf="section.required == true">*</span>
                                    </div>                                    
                                    <div class=" eac-label-caption alert-msg " *ngIf="formSectionMetadataState()[index].validForm == false  && ep._isExpanded() == false">Conté errors</div>

                                </div>                                
                            </div>
                           
    
                        </div>
                        
                    </mat-panel-title>
                    
                </mat-expansion-panel-header>

                <div [class.first-line]="isFirstSection(index)&& isLastSection(index)==false" [class.line]="isFirstSection(index) == false && isLastSection(index)==false"  [class.end-line]="isLastSection(index)&& isFirstSection(index)==false " [class.unique-line]="isLastSection(index)&& isFirstSection(index)" ></div>
                
                <ng-container 
                    *ngIf="_openedComponentSection != null && _openedDynFormSection != null && _openedDynFormSection.id == section.id && ep._isExpanded() ">
                    
                    <ng-template #refComponent [cdkPortalOutlet]="_openedComponentSection">
                    </ng-template>

                </ng-container>

            </mat-expansion-panel>

        </ng-container>

    </mat-accordion>

</div>
